import { Divider, Stack, Typography } from '@mui/joy';
import { FC } from 'react';

import MPCheckbox from '@MP/shared/components/check/MPCheckbox';
import Section from '@MP/shared/components/Section';

const AgreementList: FC<{
  patientRegistration?: boolean;
  showPatientRegistration?: boolean;
  onChangePatientRegistration?: (checked: boolean) => void;
  stimHome?: boolean;
  showStimHome?: boolean;
  onChangeStimHome?: (checked: boolean) => void;
}> = ({
  patientRegistration = false,
  showPatientRegistration = false,
  onChangePatientRegistration,
  stimHome = false,
  showStimHome = false,
  onChangeStimHome,
}) => {
  // 노출된 항목이 모두 선택된 경우 '전체 선택' 체크
  const allChecked =
    (!showPatientRegistration || patientRegistration) && (!showStimHome || stimHome);

  const handleChangeAll = (checked: boolean) => {
    if (showPatientRegistration) onChangePatientRegistration?.(checked);
    if (showStimHome) onChangeStimHome?.(checked);
  };

  return (
    <Stack height={'100%'} sx={{ overflow: 'auto' }}>
      <Typography sx={{ fontSize: 13, color: '#666', fontWeight: 500 }}>발송할 동의서 선택</Typography>
      <Section sx={{ px: '16px', mt: '8px', overflow: 'auto', flexGrow: 1 }}>
        <Stack divider={<Divider />}>
          <Stack direction={'row'} justifyContent={'space-between'} alignItems={'center'} height={'70px'}>
            <MPCheckbox checked={allChecked} label="전체 선택" primaryBorder onChange={handleChangeAll} />
          </Stack>
          {showPatientRegistration && (
            <AgreementItem
              checked={patientRegistration}
              label="MINDD 서비스 이용 동의"
              onChange={(checked) => onChangePatientRegistration?.(checked)}
            />
          )}
          {showStimHome && (
            <AgreementItem
              checked={stimHome}
              label="STIM HOME 서비스 이용 동의"
              onChange={(checked) => onChangeStimHome?.(checked)}
            />
          )}
        </Stack>
      </Section>
    </Stack>
  );
};

const AgreementItem: FC<{
  checked: boolean;
  label: string;
  onChange: (checked: boolean) => void;
}> = ({ checked, label, onChange }) => {
  return (
    <Stack direction={'row'} justifyContent={'space-between'} alignItems={'center'} height={'70px'}>
      <MPCheckbox checked={checked} label={label} primaryBorder onChange={onChange} />
    </Stack>
  );
};

export default AgreementList;
